import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../../../ui/Badge';
import { cn } from '@hero/web-lib';
import type { MemberType } from '@hero/schema';

const TYPE_CLASSES: Record<MemberType, string> = {
  admin: 'bg-blue-50 text-blue-700 border-blue-200',
  dispatcher: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  driver: 'bg-amber-50 text-amber-700 border-amber-200',
  employee: 'bg-gray-50 text-gray-700 border-gray-200',
};

export interface MemberTypeBadgeProps {
  type: string;
  className?: string;
}

export function MemberTypeBadge({ type, className }: MemberTypeBadgeProps) {
  const { t } = useTranslation(['m-member']);
  const typeClass = TYPE_CLASSES[type as MemberType] ?? TYPE_CLASSES.employee;

  return (
    <Badge variant="outline" className={cn(typeClass, className)}>
      {t(`types.${type}.title`, { defaultValue: type })}
    </Badge>
  );
}
